import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue";
import ModalGenerateImageVariations from '@/components/modal/ModalGenerateImageVariations.vue';
import ModalGenerateVariations from '@/components/modal/ModalGenerateVariations.vue';
import ModalQuickActionVariations from '@/components/modal/ModalQuickActionVariations.vue';
import ModalShowImageVariations from '@/components/modal/ModalShowImageVariations.vue';
import ModalShowVariations from '@/components/modal/ModalShowVariations.vue';
import { CUSTOM_CONTENT_LENGTH, IMAGE_GENERATION_DEFAULTS, } from '@/helper/const';
import { setupVueI18n } from '@/plugin/vue-i18n';
import '@gohighlevel/ghl-ui/dist/style.css';
import { NNotificationProvider } from 'naive-ui';
import { onMounted, onUnmounted, provide, ref } from 'vue';
import { ContentWordLimitKeys, } from '../types';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        route: Object,
        router: Object,
        emitter: Object,
        store: Object,
        user: Object,
        locale: String,
    },
    setup(__props) {
        const props = __props;
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('store', props.store);
        provide('user', props.user);
        provide('locale', props.locale);
        setupVueI18n(props.locale);
        const showGenerateVariationModal = ref(false);
        const showGenerateImageVariationModal = ref(false);
        const showVariationsModal = ref(false);
        const showImageVariationsModal = ref(false);
        const transactionId = ref('');
        const productType = ref();
        const subType = ref();
        const formValues = ref();
        const pendoProperties = ref();
        const showQuickActionModal = ref(false);
        const quickActionSelectedText = ref('');
        const quickActionContextualType = ref();
        const quickActionSessionId = ref('');
        function closeGenerateImageVariationsModal() {
            showGenerateImageVariationModal.value = false;
        }
        function closeGenerateVariationsModal() {
            showGenerateVariationModal.value = false;
        }
        function openVariation(id) {
            closeGenerateVariationsModal();
            transactionId.value = id;
            showVariationsModal.value = true;
        }
        function openImageVariation(id) {
            closeGenerateImageVariationsModal();
            transactionId.value = id;
            showImageVariationsModal.value = true;
        }
        function closeVariation() {
            showVariationsModal.value = false;
        }
        function closeImageVariation() {
            showImageVariationsModal.value = false;
        }
        function openGenerateVariations(data) {
            closeVariation();
            setData({
                source: data.source,
                type: data.type,
            });
            formValues.value = data.formValues;
            showGenerateVariationModal.value = true;
        }
        function openGenerateImageVariations(data) {
            closeImageVariation();
            setData({
                source: data.source,
                type: data.type,
            });
            formValues.value = data.formValues;
            showGenerateImageVariationModal.value = true;
        }
        function setData(data) {
            productType.value = data.source;
            subType.value = data.type;
            pendoProperties.value = data.pendoProperties;
        }
        function emitContentId(id) {
            props.emitter.emit('content-ai-generated-content', id);
        }
        function emitImageId(id) {
            props.emitter.emit('content-ai-generated-image', id);
        }
        function emitQuickActionSessionId(data) {
            props.emitter.emit('quick-action-generated-session', data);
        }
        const contentAiVariationsGenerate = (data) => {
            formValues.value = {
                title: '',
                description: '',
                keywords: [],
                tone: '',
                numberOfVariations: 3,
                subType: '',
                emailContext: '',
                lengthOfContent: ContentWordLimitKeys.SMALL,
                customLengthOfContent: CUSTOM_CONTENT_LENGTH.DEFAULT,
            };
            showGenerateVariationModal.value = true;
            setData(data);
        };
        const imageAiGenerate = (data) => {
            formValues.value = {
                description: IMAGE_GENERATION_DEFAULTS.DESCRIPTION,
                numberOfVariations: IMAGE_GENERATION_DEFAULTS.NUMBER_OF_VARIATIONS,
                preset: IMAGE_GENERATION_DEFAULTS.PRESET,
            };
            showGenerateImageVariationModal.value = true;
            setData(data);
        };
        const contentAiVariationsShow = (data) => {
            setData(data);
            openVariation(data.id);
        };
        const imageAiVariationsShow = (data) => {
            setData(data);
            openImageVariation(data.id);
        };
        function setQuickActionData(data) {
            productType.value = data.source;
            subType.value = data.type;
            quickActionContextualType.value = data.contextualType;
            quickActionSelectedText.value = data.selectedText;
        }
        function closeQuickAction() {
            showQuickActionModal.value = false;
        }
        const contentAIQuickAction = (data) => {
            setQuickActionData(data);
            showQuickActionModal.value = true;
        };
        onMounted(() => {
            var _a, _b, _c, _d, _e;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.on('content-ai-variations-generate', contentAiVariationsGenerate);
            (_b = props.emitter) === null || _b === void 0 ? void 0 : _b.on('image-ai-generate', imageAiGenerate);
            (_c = props.emitter) === null || _c === void 0 ? void 0 : _c.on('content-ai-variations-show', contentAiVariationsShow);
            (_d = props.emitter) === null || _d === void 0 ? void 0 : _d.on('image-ai-variations-show', imageAiVariationsShow);
            (_e = props.emitter) === null || _e === void 0 ? void 0 : _e.on('content-ai-quick-action', contentAIQuickAction);
        });
        onUnmounted(() => {
            var _a, _b, _c, _d, _e;
            (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.off('content-ai-variations-generate', contentAiVariationsGenerate);
            (_b = props.emitter) === null || _b === void 0 ? void 0 : _b.off('image-ai-generate', imageAiGenerate);
            (_c = props.emitter) === null || _c === void 0 ? void 0 : _c.off('content-ai-variations-show', contentAiVariationsShow);
            (_d = props.emitter) === null || _d === void 0 ? void 0 : _d.off('image-ai-variations-show', imageAiVariationsShow);
            (_e = props.emitter) === null || _e === void 0 ? void 0 : _e.off('content-ai-quick-action', contentAIQuickAction);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(NNotificationProvider), null, {
                default: _withCtx(() => [
                    _createElementVNode("div", null, [
                        (productType.value)
                            ? (_openBlock(), _createBlock(ModalGenerateVariations, {
                                key: 0,
                                "show-modal": showGenerateVariationModal.value,
                                onClose: closeGenerateVariationsModal,
                                productType: productType.value,
                                "sub-type": subType.value,
                                "form-data": formValues.value,
                                "pendo-properties": pendoProperties.value,
                                onShowVariations: openVariation
                            }, null, 8 /* PROPS */, ["show-modal", "productType", "sub-type", "form-data", "pendo-properties"]))
                            : _createCommentVNode("v-if", true),
                        _createVNode(ModalShowVariations, {
                            "show-modal": showVariationsModal.value,
                            "transaction-id": transactionId.value,
                            productType: productType.value,
                            onClose: closeVariation,
                            onRegenerate: openGenerateVariations,
                            onContentId: emitContentId
                        }, null, 8 /* PROPS */, ["show-modal", "transaction-id", "productType"]),
                        (productType.value)
                            ? (_openBlock(), _createBlock(ModalGenerateImageVariations, {
                                key: 1,
                                "show-modal": showGenerateImageVariationModal.value,
                                onClose: closeGenerateImageVariationsModal,
                                productType: productType.value,
                                "form-data": formValues.value,
                                "pendo-properties": pendoProperties.value,
                                onShowVariations: openImageVariation
                            }, null, 8 /* PROPS */, ["show-modal", "productType", "form-data", "pendo-properties"]))
                            : _createCommentVNode("v-if", true),
                        _createVNode(ModalShowImageVariations, {
                            "show-modal": showImageVariationsModal.value,
                            "transaction-id": transactionId.value,
                            productType: productType.value,
                            onClose: closeImageVariation,
                            onRegenerate: openGenerateImageVariations,
                            onImageId: emitImageId
                        }, null, 8 /* PROPS */, ["show-modal", "transaction-id", "productType"]),
                        _createVNode(ModalQuickActionVariations, {
                            showModal: showQuickActionModal.value,
                            sessionId: quickActionSessionId.value,
                            productType: productType.value,
                            subType: subType.value,
                            selectedText: quickActionSelectedText.value,
                            contextualType: quickActionContextualType.value,
                            onClose: closeQuickAction,
                            onUpdateSessionId: emitQuickActionSessionId
                        }, null, 8 /* PROPS */, ["showModal", "sessionId", "productType", "subType", "selectedText", "contextualType"])
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
